import { render } from "./ReturnAndRefundListComponent.vue?vue&type=template&id=17bea400&scoped=true"
import script from "./ReturnAndRefundListComponent.vue?vue&type=script&lang=js"
export * from "./ReturnAndRefundListComponent.vue?vue&type=script&lang=js"

import "./ReturnAndRefundListComponent.vue?vue&type=style&index=0&id=17bea400&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bea400"],['__file',"resources/js/components/admin/returnAndRefunds/ReturnAndRefundListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17bea400"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17bea400', __exports__)) {
    api.reload('17bea400', __exports__)
  }
  
  module.hot.accept("./ReturnAndRefundListComponent.vue?vue&type=template&id=17bea400&scoped=true", () => {
    api.rerender('17bea400', render)
  })

}


export default __exports__